module.exports = __webpack_public_path__ + "media/images/games/k2gender/cat-56a8da4a44234eafadfe0fa95ab6ed9a.png";